import { connect } from 'react-redux';
import { compose, setPropTypes, withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import { addOwnerCustomer } from '../../../../main/customers/actions';
import withActiveUserIdAndType from '../../../hoc/withActiveUserIdAndType';

const AddCustomerModalContainer = compose(
  withActiveUserIdAndType(),
  setPropTypes({
    onAfterSubmit: PropTypes.func,
  }),
  connect(null, { addOwnerCustomer }),
  withHandlers({
    onSubmit: props => data => props.addOwnerCustomer(props.activeId, props.activeType, data)
      .then((customer) => {
        if (typeof props.onAfterSubmit === 'function') props.onAfterSubmit(customer);
      }),
  }),
);

export default AddCustomerModalContainer;
